<script>
  import FontDropdown from "./Components/fontDropdown.svelte"
  import { onMount, onDestroy, tick } from "svelte"
  import LinkModal from "./Components/linkModal.svelte"
  import Palette from "./Modules/Palette/index.svelte"
  import AttributeModal from "./Modules/AttributeModal/index.svelte"
  import UserinfoModal from "./Components/userinfoModal.svelte"
  import { flatenObject } from "../../../../../Script/flatenObject"

  export let page = "Edit"

  export let color = "#ffffff"

  export let displayValue = false

  export let parsedJson = {}
  /**
   * @type {String} content of the text editor
   */
  export let content = ""
  /**
   * @type {String} source for the QR Image to display
   */
  export let qrSource = ""
  /**
   * @type {Array<String>} list of font families
   */
  let fontFamily = ["Arial", "Arial Black", "Courier New", "Comic Sans MS", "Times New Roman", "Helvetica", "Impact", "Tahoma", "Verdana"]
  /**
   * @type {Array<Number>} list of font sizes
   */
  let fontSize = [1, 2, 3, 4, 5, 6, 7]
  /**
   * @type {String} indicates the active font style such as h1,h2,h3.....
   */
  let activeStyle
  /**
   * @type {Number} indicates the active font size
   */
  let activeFontSize
  /**
   * @type {String} indicates the active font family
   */
  let activeFontFamily
  /**
   *  @type {Boolean} for toggling the codeview
   */
  let codeView = false
  /**
   * @type {HTMLElement} binded the codearea html element
   */
  let codearea
  /**
   * @type {HTMLElement} binded the textarea html element
   */
  let textarea
  /**
   * @type {HTMLElement} binded the italic btn html element
   */
  let italicBtn
  /**
   * @type {HTMLElement} binded the bold btn html element
   */
  let boldBtn
  /**
   * @type {HTMLElement} binded the bold btn html element
   */
  let underlineBtn
  /**
   * @type {HTMLElement} binded the justifyLeft btn html element
   */
  let justifyLeft
  /**
   * @type {HTMLElement} binded the justifyCenter btn html element
   */
  let justifyCenter
  /**
   * @type {HTMLElement} binded the justifyRight btn html element
   */
  let justifyRight
  /**
   * @type {HTMLElement} binded the justifyFull btn html element
   */
  let justifyFull
  /**
   * @type {HTMLElement} binded the olBtn btn html element
   */
  let olBtn
  /**
   * @type {HTMLElement} binded the indent btn html element
   */
  let ulBtn
  /**
   * @type {Boolean} toggling to show the link Modal
   */
  let showLinkModal = false
  /**
   * @type {Boolean} toggling to show the attribute Modal
   */
  let showAttributeModal = false
  /**
   * @type {String} indicates the text color to be applied for the text in editor
   */
  let textColor
  // let textColor = "rgb(229 ,231 ,235)"
  /**
   * @type {String} indicates the background color to be applied for the text in editor
   */
  let backgroundColor
  /**
   * @type {Selection} indicates the selected text object from the document
   */
  let selected
  /**
   * @type {Node} the node where the selection starts
   */
  let anchorNode
  /**
   * @type {Node} the previous node of the selection starts
   */
  let anchorNodePrevious
  /**
   * @type {Node} the node where the selection ends,
   */
  let focusNode
  /**
   * @type {Node} the next node of the selection ends,
   */
  let focusNodeNext
  /**
   * @type {Number} the offset in focusNode where the selection ends,
   */
  let focusOffset
  /**
   * @type {Number} the offset in anchorNode where the selection starts
   */
  let anchorOffset
  /**
   * @type {Boolean} whether to show the user info modal or not
   */
  let showUserInfoModal = false

  let mainContainer

  let toolbar

  let editorHeight

  /**
   * @description Function for assigning the scroll height to the textarea
   */
  const autoGrow = () => {
    // Check if the textarea element exists
    if (textarea) {
      // Set the height of the textarea element to its scrollHeight
      // textarea.style.height = textarea.scrollHeight + "px"
    }
  }
  /**
   * @description Function for assigning the scroll height to the codearea
   */
  const autoGrowCodeView = () => {
    // Check if the codearea element exists
    if (codearea) {
      // Set the height of the codearea element to its scrollHeight
      // codearea.style.height = codearea.scrollHeight + "px"
    }
  }

  onMount(() => {
    if (page == "Carousel") {
      editorHeight = mainContainer.clientHeight - 12 - toolbar.clientHeight - 49.6
    } else {
      editorHeight = (mainContainer.clientWidth * 2) / 4
    }
    cleanEditor()
  })

  /**
   * @description Function for toggling the codeview
   */
  const changeCodeView = () => {
    // Toggling the codeView
    codeView = !codeView

    // Check if codeView is true
    if (codeView) {
      // If true, execute the following code after a delay of 10 milliseconds
      setTimeout(() => {
        // Define a regular expression pattern to match CSS utility classes in the codearea.innerText
        let pattern = /--tw-[a-z\-]+:\s?[^;]+;\s?/g

        // Replace all occurrences of the pattern in the codearea.innerText with an empty string to remove the utility classes
        codearea.innerText = codearea.innerText.replace(pattern, "")
      }, 10)
    }
  }

  class NodeData {
    constructor(state = false) {
      this.bold = state
      this.italic = state
      this.underline = state
      this.justifyLeft = state
      this.justifyRight = state
      this.justifyCenter = state
      this.justifyFull = state
      this.insertUnorderedList = state
      this.insertOrderedList = state
      this.fontName = "Arial"
      // this.textColor = "black"
      // this.backgroundColor = "white"
      this.fontSize = 1
      this.fontStyle = "p"
    }

    /**
     * @typedef {Object} NodeData
     * @param {boolean} bold
     * @param {boolean} italic
     * @param {boolean} underline
     * @param {boolean} justifyLeft
     * @param {boolean} justifyRight
     * @param {boolean} justifyCenter
     * @param {boolean} justifyFull
     * @param {boolean} insertUnorderedList
     * @param {boolean} insertOrderedList
     * @param {boolean} fontName
     * @param {boolean} fontSize
     * @param {boolean} textColor
     * @param {boolean} backgroundColor
     * @param {boolean} fontStyle
     */
    /**
     * @returns {NodeData}
     */
    getData() {
      return {
        bold: this.bold,
        italic: this.italic,
        underline: this.underline,
        justifyLeft: this.justifyLeft,
        justifyCenter: this.justifyCenter,
        justifyRight: this.justifyRight,
        justifyFull: this.justifyFull,
        insertUnorderedList: this.insertUnorderedList,
        insertOrderedList: this.insertOrderedList,
        fontName: this.fontName,
        // textColor: this.textColor,
        // backgroundColor: this.backgroundColor,
        fontSize: this.fontSize,
        fontStyle: this.fontStyle,
      }
    }
  }

  /**
   * @description Function for highlighting the font style btns
   * @param {NodeData} nodeData
   */
  const highlightBtns = (nodeData) => {
    // Check if the 'bold' property in nodeData is true
    if (nodeData.bold) {
      // If true, add the "active" class to boldBtn
      boldBtn.classList.add("active")
    } else {
      // If false, remove the "active" class from boldBtn
      boldBtn.classList.remove("active")
    }

    // Check if the 'italic' property in nodeData is true
    if (nodeData.italic) {
      // If true, add the "active" class to italicBtn
      italicBtn.classList.add("active")
    } else {
      // If false, remove the "active" class from italicBtn
      italicBtn.classList.remove("active")
    }

    // Check if the 'underline' property in nodeData is true
    if (nodeData.underline) {
      // If true, add the "active" class to underlineBtn
      underlineBtn.classList.add("active")
    } else {
      // If false, remove the "active" class from underlineBtn
      underlineBtn.classList.remove("active")
    }

    // Check if the 'justifyLeft' property in nodeData is true
    if (nodeData.justifyLeft) {
      // If true, add the "active" class to justifyLeft
      justifyLeft.classList.add("active")
    } else {
      // If false, remove the "active" class from justifyLeft
      justifyLeft.classList.remove("active")
    }

    // Check if the 'justifyCenter' property in nodeData is true
    if (nodeData.justifyCenter) {
      // If true, add the "active" class to justifyCenter
      justifyCenter.classList.add("active")
    } else {
      // If false, remove the "active" class from justifyCenter
      justifyCenter.classList.remove("active")
    }

    // Check if the 'justifyRight' property in nodeData is true
    if (nodeData.justifyRight) {
      // If true, add the "active" class to justifyRight
      justifyRight.classList.add("active")
    } else {
      // If false, remove the "active" class from justifyRight
      justifyRight.classList.remove("active")
    }

    // Check if the 'justifyFull' property in nodeData is true
    if (nodeData.justifyFull) {
      // If true, add the "active" class to justifyFull
      justifyFull.classList.add("active")
    } else {
      // If false, remove the "active" class from justifyFull
      justifyFull.classList.remove("active")
    }

    // Check if the 'insertUnorderedList' property in nodeData is true
    if (nodeData.insertUnorderedList) {
      // If true, add the "active" class to ulBtn
      ulBtn.classList.add("active")
    } else {
      // If false, remove the "active" class from ulBtn
      ulBtn.classList.remove("active")
    }

    // Check if the 'insertOrderedList' property in nodeData is true
    if (nodeData.insertOrderedList) {
      // If true, add the "active" class to olBtn
      olBtn.classList.add("active")
    } else {
      // If false, remove the "active" class from olBtn
      olBtn.classList.remove("active")
    }

    // Update the activeFontFamily with the value of nodeData.fontName
    if (nodeData.fontName) {
      activeFontFamily = nodeData.fontName
    }

    // Update the activeFontSize with the value of nodeData.fontSize
    if (nodeData.fontSize) {
      activeFontSize = nodeData.fontSize
    }

    // Update the activeStyle with the value of nodeData.fontStyle
    if (nodeData.fontStyle) {
      activeStyle = nodeData.fontStyle
    }
  }

  /**
   * Toggles formatting for the selected text using the `execCommand` method.
   * @param {"bold" | "italic" | "underline"} style
   * @returns {NodeData} The formatting data of the anchor node after execCommand exexcution.
   */
  const toggleStyleExec = (style) => {
    moveCursorToEnd()

    // check correct parameter is passed
    if (style != "bold" && style != "italic" && style != "insertUnorderedList" && style != "insertOrderedList" && style != "underline" && style != "justifyLeft" && style != "justifyCenter" && style != "justifyRight" && style != "justifyFull") return

    // document.execCommand("styleWithCSS", true, null)

    // Execute the "bold" | "italic" | "underline" command using the `execCommand` method
    document.execCommand(style, false, "")
    let nodeData = getSelectedFormattingInfo()

    highlightBtns(nodeData.getData())
  }

  /**
   * Retrieves the formatting information of a given node
   * @returns {Object} The formatting information object for the node.
   */
  const getSelectedFormattingInfo = () => {
    // Create a new instance of the NodeData class
    let nodeData = new NodeData()

    // Retrieve the formatting information using document.queryCommandState and document.queryCommandValue
    nodeData.bold = document.queryCommandState("bold")
    nodeData.italic = document.queryCommandState("italic")
    nodeData.underline = document.queryCommandState("underline")
    nodeData.justifyLeft = document.queryCommandState("justifyLeft")
    nodeData.justifyCenter = document.queryCommandState("justifyCenter")
    nodeData.justifyRight = document.queryCommandState("justifyRight")
    nodeData.justifyFull = document.queryCommandState("justifyFull")
    nodeData.insertUnorderedList = document.queryCommandState("insertUnorderedList")
    nodeData.insertOrderedList = document.queryCommandState("insertOrderedList")
    nodeData.fontName = document.queryCommandValue("fontName")
    // nodeData.textColor = document.queryCommandValue("foreColor");
    // nodeData.backgroundColor = document.queryCommandValue("backColor");
    nodeData.fontSize = document.queryCommandValue("fontSize")
    nodeData.fontStyle = document.queryCommandValue("formatBlock")

    // Return the nodeData object containing the formatting information
    return nodeData
  }

  const cleanEditor = () => {
    moveLeadingSpaces(textarea)
    removeRedundantNestedElements(textarea)
  }

  /**
   * @param {Node|HTMLElement} node
   *
   */
  const moveLeadingSpaces = (node) => {
    // Check if the node is a text node
    if (node.nodeType == Node.TEXT_NODE) {
      // If it is a text node, call the function moveLeadingSpacesToPreviousNode and return its result
      return moveLeadingSpacesToPreviousNode(node)
    }

    // Iterate through the child nodes of the current node
    for (let i = 0; i < node.childNodes.length; i++) {
      // Recursively call the moveLeadingSpaces function for each child node
      moveLeadingSpaces(node.childNodes[i])
    }

    // Return nothing
    return
  }

  /**
   * @param {Document|DocumentFragment} document
   * Removes redundant nested elements in the body of an editor.
   */
  const removeRedundantNestedElements = (document = document) => {
    // Select all elements inside the body of the document.
    let elements = document.querySelectorAll("body *")

    // Iterate over each element.
    elements.forEach(function (element) {
      // Check if the parent node has the same name as the current element.
      if (element.parentNode.nodeName.toLowerCase() === element.nodeName.toLowerCase()) {
        // If the parent node and the current element have the same name,
        // move all child nodes of the element to the parent node.
        while (element.firstChild) {
          element.parentNode.insertBefore(element.firstChild, element)
        }

        // Remove the current element from its parent.
        element.parentNode.removeChild(element)
      }
    })
  }

  /**
   * @description Moves leading spaces from a node to the previous sibling text node or parent text node.
   * @param {Node} node - The node to process.
   */
  const moveLeadingSpacesToPreviousNode = (node) => {
    // Check if the node is a text node
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent // Get the text content of the node
      const leadingSpaces = text.match(/^\s+/) // Check if the text has leading spaces using a regular expression
      const onlySpaces = /^\s+$/.test(text) // Check if the text consists only of spaces using a regular expression

      // Check if leading spaces are found and the text is not only spaces
      if (leadingSpaces && !onlySpaces) {
        let previousNode = node.previousSibling // Get the previous sibling node

        // Iterate through previous siblings and their last children
        while (previousNode) {
          // Check if the previous sibling is a text node
          if (previousNode.nodeType === Node.TEXT_NODE) {
            previousNode.textContent += leadingSpaces[0] // Add the leading spaces to the previous sibling
            node.textContent = text.trimStart() // Remove the leading spaces from the current node
            return // Exit the function
          } else if (previousNode.lastChild) {
            previousNode = previousNode.lastChild // Move to the last child of the previous sibling
          } else {
            break // If the previous sibling has no last child, exit the loop
          }
        }

        // If no previous sibling text node is found, traverse up the DOM tree
        let parentNode = node.parentNode

        while (parentNode && parentNode.nodeType !== Node.DOCUMENT_NODE) {
          const previousSibling = parentNode.previousSibling

          // Check if the previous sibling of the parent node is a text node
          if (previousSibling && previousSibling.nodeType === Node.TEXT_NODE) {
            previousSibling.textContent += leadingSpaces[0] // Add the leading spaces to the previous sibling
            node.textContent = text.trimStart() // Remove the leading spaces from the current node
            return // Exit the function
          }

          parentNode = parentNode.parentNode // Move to the parent node
        }
      }
    }
  }

  /**
   * @description Function for highlighting btns while clicking the text
   */
  const showRange = () => {
    let nodeData = getSelectedFormattingInfo()
    highlightBtns(nodeData.getData())
  }

  $: applyStyle(activeStyle)

  /**
   * @description Function for applying the font styles like h1,h2,h3,h4,h5,h6.............
   * @param {String} activeStyle the active font style to be applied
   */
  const applyStyle = (activeStyle) => {
    // Execute the formatBlock command to apply the specified text style
    document.execCommand("formatBlock", false, activeStyle)
  }

  /**
   * @desription Function for creating ordered and unordered list
   * @param {String} command command for creating the list
   */
  const createList = (command) => {
    moveCursorToEnd()

    // Execute the specified command to create a list
    document.execCommand(command, false, "")

    // Get the formatting information of the selected content
    let nodeData = getSelectedFormattingInfo()

    // Update the highlighting of the buttons based on the formatting information
    highlightBtns(nodeData.getData())
  }

  /**
   * @description Function for remove the format of the current selection
   */
  const removeFormatting = () => {
    moveCursorToEnd()

    // Execute the "removeFormat" command to remove the formatting from the selected text
    document.execCommand("removeFormat", false, "")

    // Call the getSelectedFormattingInfo function to retrieve the formatting information of the selected text
    let nodeData = getSelectedFormattingInfo()

    // Call the highlightBtns function to update the UI based on the formatting information
    highlightBtns(nodeData.getData())
  }

  // $: applyFontSize(activeFontSize)

  /**
   * @description Function for applying the font size
   * @param {Number} activeFontSize the font size selected by the user
   */
  const applyFontSize = async (activeFontSize) => {
    // document.getSelection().setBaseAndExtent(e.anchorNode, e.anchorOffset, e.focusNode, e.focusOffset)

    // style with CSS rather than HTML
    // document.execCommand("styleWithCSS", false, "true")

    // Execute the "fontSize" command to apply the specified font size to the selected text
    document.execCommand("fontSize", false, activeFontSize)

    // await tick()

    // e.anchorNode.parentNode.style.fontSize = "30px"

    // document.execCommand("insertHTML", false, `<span style="font-size: 20px">${document.getSelection().toString()}</span>`)

    // document.getSelection().setBaseAndExtent(e.anchorNode, 0, e.focusNode, e.focusNode.nodeValue.length)
  }

  $: applyFontFamily(activeFontFamily)

  /**
   * @description Function for applying the font family
   * @param {String} activeFontFamily the font family selected by the user
   */
  const applyFontFamily = (activeFontFamily) => {
    // Execute the "fontName" command to apply the specified font family to the selected text
    document.execCommand("fontName", false, activeFontFamily)
  }

  /**
   * @description Function for changing the indentation/outdentation of the content
   * @param {"indent"|"outdent"} command doc execCommand for indentation
   */
  const changeIndent = (command) => {
    moveCursorToEnd()
    // Execute the specified command to change the indentation of the selected text
    document.execCommand(command, false, "")
  }

  /**
   * @description Function for changing the text color of the text content
   */
  const changeColor = () => {
    moveCursorToEnd()

    // Execute the "foreColor" command to change the text color of the selected text
    document.execCommand("styleWithCSS", false, "true")
    document.execCommand("foreColor", false, textColor)

    document.execCommand("styleWithCSS", false, "true")
    if (!document.execCommand("hiliteColor", false, backgroundColor)) {
      document.execCommand("backColor", false, backgroundColor)
    }
  }

  /**
   * @description Function for changing the background color of the text content
   */
  const changeBgColor = () => {
    moveCursorToEnd()
    // change text background color to blue
    document.execCommand("styleWithCSS", false, "true")
    if (!document.execCommand("hiliteColor", false, backgroundColor)) {
      document.execCommand("backColor", false, backgroundColor)
      // executes backColor command if hiliteColor returns false, indicating browser is internet explorer
    }
  }

  $: trackChangeColor(textColor, backgroundColor)

  /**
   * @description Function for tracking the changes in text and bg color reactively
   */
  const trackChangeColor = (textColor, backgroundColor) => {
    changeColor()
  }

  /**
   * @description Function for storing the selection values
   */
  const storeSelection = () => {
    // Get the current selection using document.getSelection()
    selected = document.getSelection()

    // console.log(selected)
    // console.log(selected?.anchorNode?.parentElement?.id, "anchorNode")

    // selected.isCollapsed || selected.type == "None" ||

    // Find the nearest element container
    let container = selected?.anchorNode?.nodeType === Node.ELEMENT_NODE ? selected.anchorNode : selected?.anchorNode?.parentElement

    // Check if selection is inside #textEditor
    const isInsideEditor = container?.closest("#textEditor")

    if (!isInsideEditor) {
      // console.log("Outside editor → move cursor to end")
      moveCursorToEnd()
      selected = document.getSelection()
    }

    // Store various properties of the selection for later use
    anchorNode = selected.anchorNode
    focusNode = selected.focusNode
    focusOffset = selected.focusOffset
    anchorOffset = selected.anchorOffset

    // console.log(GetParentNode(anchorNode))

    // Get the previous sibling of the anchorNode using the GetPreviousSibling() function
    anchorNodePrevious = GetPreviousSibling(anchorNode)

    // Get the next sibling of the focusNode using the GetNextSibling() function
    focusNodeNext = GetNextSibling(focusNode)
  }

  /**
   * @description Function for fetching the parent Element which is the anchorElement(<a></a>)
   * @param {Node|HTMLElement} node
   * @return {null|Node|HTMLElement}
   */
  const GetParentNode = (node) => {
    // Check if the parent node is an anchor element
    if (node.parentNode.nodeName == "A") {
      return node.parentNode
    }
    // If the parent node is not an anchor element, recursively call GetParentNode on its parent node
    else if (node.parentNode.nodeName != "A") {
      return GetParentNode(node.parentNode)
    }
    // If none of the conditions match, return null
    else {
      return null
    }
  }

  /**
   * @description Function for getting the previous sibling of the particular node
   * @param {Node|HTMLElement} node
   * @return {null|Node|HTMLElement}
   */
  const GetPreviousSibling = (node) => {
    // Check if the node has a previous sibling
    if (node.previousSibling != null) {
      return node.previousSibling
    }
    // If the node doesn't have a previous sibling, check if it has a parent node
    else if (node.parentNode != null) {
      return GetPreviousSibling(node.parentNode)
    }
    // If none of the conditions match, return null
    else {
      return null
    }
  }

  /**
   * @description Function for getting the next sibling of the particular node
   * @param {Node|HTMLElement} node
   * @return {null|Node|HTMLElement}
   */
  const GetNextSibling = (node) => {
    // Check if the node has a next sibling
    if (node.nextSibling != null) {
      return node.nextSibling
    }
    // If the node doesn't have a next sibling, check if it has a parent node
    else if (node.parentNode != null) {
      return GetNextSibling(node.parentNode)
    }
    // If none of the conditions match, return null
    else {
      return null
    }
  }

  /**
   * @description Function for getting the last text node of the particular node
   * @param {Node|HTMLElement} node
   * @return {Node|null}
   */
  const getLastTextNode = (node) => {
    // Check if the node has more than one child node
    if (node.childNodes.length > 1) {
      // Recursively call getLastTextNode on the last child node
      return getLastTextNode(node.lastChild)
    }
    // Check if the last child node is a text node
    if (node.lastChild.nodeType == 3) {
      // Return the last child node if it is a text node
      return node.lastChild
    } else {
      // Return null if the last child node is not a text node
      return null
    }
  }

  /**
   * @description Function for getting the first text node of the particular node
   * @param {Node|HTMLElement} node
   * @return {Node|null}
   */
  const getFirstTextNode = (node) => {
    // Check if the node has at least one child node
    if (node.childNodes.length >= 1) {
      // Recursively call getFirstTextNode on the first child node
      return getFirstTextNode(node.firstChild)
    }
    // Check if the first child node exists and is a text node
    if (node.firstChild) {
      if (node.firstChild.nodeType == 3) {
        // Return the first child node if it is a text node
        return node.firstChild
      }
    }
    // Check if the current node is a text node
    if (node.nodeType == 3) {
      // Return the current node if it is a text node
      return node
    } else {
      // Return null if the first child node and the current node are not text nodes
      return null
    }
  }

  /**
   * @description Function for inserting the link after closing the link Modal
   * @param e {String} the url to embed for the selected text
   */
  const insertLink = async (e) => {
    // Set the selection range to the original anchor and focus nodes and offsets
    document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

    // Insert the hyperlink using the createLink command and the provided URL
    // document.execCommand("createLink", false, e.detail.url)

    document.execCommand("insertHTML", false, `<a href="${e.detail.url}" target="_blank">${e.detail.title}</a>`)
    // document.execCommand('insertHTML', false, `<a href="${e.detail.url}" style="color:blue;text-decoration:underline" target="_blank">${e.detail.title}</a>`);

    let regex = /<a[^>]*>{{url}}<\/a>/g

    content = content.replace(regex, function (match) {
      return match.replace(/href="[^"]*"/, 'href="{{url}}"')
    })

    // document.execCommand("insertText", false, e.detail.title)
  }

  /**
   * @description Function for inserting the attribute
   * @param e {String} the selected attribute value
   */
  const insertAttribute = async (e) => {
    // Set the selection range to the original anchor and focus nodes and offsets
    document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

    // if (!document.getSelection().isCollapsed) {
    //   // anchorNode value of the selected text
    //   let curlyValue = document.getSelection().anchorNode.nodeValue
    //   // checking whether the selected text contains curly brackets before and after
    //   let checkCurlyBrackets = curlyValue.match(/(?<=\{\{).*?(?=\}\})/g)

    //   // if the selected text contains curly brackets attribute didnt wrapped inside curly brackets otherwise viceversa
    //   // Check if the selected text contains curly brackets
    //   if (checkCurlyBrackets) {
    //     document.execCommand("insertText", false, `${e.detail}`)
    //   } else {
    //     document.execCommand("insertText", false, `{{${e.detail}}}`)
    //   }
    // } else {
    //   // Insert the attribute wrapped in curly brackets
    //   document.execCommand("insertText", false, `{{${e.detail}}}`)
    // }

    if (displayValue) {
      let flatObject = flatenObject(parsedJson)
      document.execCommand("insertText", false, flatObject[e.detail])
    } else {
      document.execCommand("insertText", false, `{{${e.detail}}}`)
    }

    await tick()

    // console.log(focusNode)

    // Update the selection range
    if (focusNode.nodeValue) {
      if (focusNode.nodeValue.length > 1) {
        // Set the selection range to the anchor and focus nodes with updated offsets
        document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusNode.nodeValue.length)
      } else {
        // Set the selection range to the first text node of the next sibling of the anchor node and the previous sibling of the focus node
        document.getSelection().setBaseAndExtent(getFirstTextNode(GetNextSibling(anchorNodePrevious)), 0, GetPreviousSibling(focusNodeNext), 0)
      }
    }
  }

  const moveCursorToEnd = () => {
    try {
      // Get the current selection
      let selection = document.getSelection()

      // Check if the selection is collapsed (no text selected)
      if (!selection.isCollapsed || !textarea) return

      textarea.focus()
      // Move cursor to the end
      let range = document.createRange()
      // let selection = window.getSelection()

      range.selectNodeContents(textarea)
      range.collapse(false) // Move to end of the content
      selection.removeAllRanges()
      selection.addRange(range)

      // console.log(selection)
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelectionChange = () => {
    // Check if the textarea element exists in the document
    if (textarea) {
      // Check if the current selection contains the textarea element
      let selectionarea = document.getSelection().containsNode(textarea, true)

      if (!selectionarea) {
        // disableStyles = true
        // console.log("hits selection change")
        let nodeData = new NodeData()

        // Retrieve the formatting information using document.queryCommandState and document.queryCommandValue
        nodeData.bold = false
        nodeData.italic = false
        nodeData.underline = false
        nodeData.justifyLeft = false
        nodeData.justifyCenter = false
        nodeData.justifyRight = false
        nodeData.justifyFull = false
        nodeData.insertUnorderedList = false
        nodeData.insertOrderedList = false

        highlightBtns(nodeData.getData())
      }
    }
  }

  /**
   * setting time for autogrow function to get auto scrollHeight
   */
  let timer = setInterval(() => {
    autoGrow()
    autoGrowCodeView()
  }, 50)

  /**
   * clearing timer for preventing autogrowing of the textarea height.
   */
  onDestroy(() => {
    clearTimeout(timer)
  })

  /**
   * Function for inserting the button at the selected cursor position
   */
  // const insertButton = async (e) => {
  //   showUserInfoModal = false

  //   // Save the current selection range
  //   document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

  //   // Variables for storing issue and expiration year/month
  //   let issueYear
  //   let issueMonth
  //   let expireYear
  //   let expireMonth

  //   // Extract issue year/month from the provided issuedDate
  //   if (e.detail.issuedDate) {
  //     issueMonth = new Date(`${e.detail.issuedDate}`).getMonth() + 1
  //     issueYear = new Date(`${e.detail.issuedDate}`).getFullYear()
  //   }

  //   // Extract expire year/month from the provided expireDate
  //   if (e.detail.expireDate) {
  //     expireMonth = new Date(`${e.detail.expireDate}`).getMonth() + 1
  //     expireYear = new Date(`${e.detail.expireDate}`).getFullYear()
  //   }

  //   // Construct the HTML button string
  //   let Button = `<span><a target="_blank" href="https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${e.detail.name}&organizationId=157272&${issueYear ? `issueYear=${issueYear}` : ""}&${issueMonth ? `issueMonth=${issueMonth}` : ""}&${expireYear ? `expirationYear=${expireYear}` : ""}&${expireMonth ? `expirationMonth=${expireMonth}` : ""}&certUrl=${e.detail.credentialURL}&certId=${e.detail.credentialID}" contenteditable="false" style="display: inline-flex;height: 36px;min-width: 36px;align-items: center;justify-content: center;border-radius: 6px;
  //     border-width: 1px;text-decoration:none;border-color: #a0a1a533;background-color: rgb(59 ,130 ,246);padding-left: 12px;padding-right: 12px;padding-top: 6px;padding-bottom: 6px;
  //     font-weight: 500;font-size: 14px;line-height: 20px;color: white">
  //       <span>
  //         <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" fill="white">
  //           <!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  //           <path
  //             d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
  //           />
  //         </svg>
  //       </span>
  //       <span class="select-none">&nbsp;&nbsp;Add to Profile</span>
  //     </a></span>`

  //   // Insert the button HTML at the current selection
  //   document.execCommand("insertHTML", false, Button)

  //   // Wait for a tick (next animation frame)
  //   await tick()

  //   // Reset the selection to the next sibling node
  //   document.getSelection().setBaseAndExtent(GetNextSibling(anchorNode), 0, GetNextSibling(anchorNode), 0)
  // }

  const insertButton = async () => {
    // Save the current selection range
    document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

    // 90539652

    // 15096409 => NISM ID

    let Button = `<span><a id="linkedInBtn" target="_blank" href="https://www.linkedin.com/profile/add?organizationId=15096409&startTask=CERTIFICATION_NAME&name=[[document_type]]&issueYear=[[issue_Year]]&issueMonth=[[issue_Month]]&expirationYear=[[expire_Year]]&expirationMonth=[[expire_Month]]&certUrl=[[cert_url]]&certId=[[cert_ID]]" contenteditable="false" style="display: inline-flex;min-width: 36px;align-items: baseline !important;border-radius: 6px;
      border-width: 1px;text-decoration:none;border-color: #a0a1a533;background-color: rgb(59 ,130 ,246);padding-left: 12px;padding-right: 12px;padding-top: 6px;padding-bottom: 6px;
      font-weight: 500;font-size: 14px;line-height: 20px;color: white;">
          <img style="width:12px;height:12px;" src="https://print2block.com/img/linkedIn-64.png" />
          <span class="select-none">&nbsp;&nbsp;Add to Profile</span>
          </a></span>`

    // Insert the button HTML at the current selection
    document.execCommand("insertHTML", false, Button)

    // Wait for a tick (next animation frame)
    await tick()

    // Reset the selection to the next sibling node
    document.getSelection().setBaseAndExtent(GetNextSibling(anchorNode), 0, GetNextSibling(anchorNode), 0)
  }

  const handleQRInclusion = async () => {
    try {
      storeSelection()

      // Save the current selection range
      document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

      let image = `<img style='width:120px' class='qr' src='${qrSource}' alt='document-QR' />`

      // Insert the button HTML at the current selection
      document.execCommand("insertHTML", false, image)

      // Wait for a tick (next animation frame)
      await tick()

      // Reset the selection to the next sibling node
      document.getSelection().setBaseAndExtent(GetNextSibling(anchorNode), 0, GetNextSibling(anchorNode), 0)
    } catch (error) {
      console.error(error)
    }
  }

  const handleBtnInsertion = async (e) => {
    try {
      showUserInfoModal = false

      document.getSelection().setBaseAndExtent(anchorNode, anchorOffset, focusNode, focusOffset)

      let Button = `<span><a id="linkedInBtn" target="_blank" href="https://www.linkedin.com/profile/add?organizationId=${e.detail}&startTask=CERTIFICATION_NAME&name=[[document_type]]&issueYear=[[issue_Year]]&issueMonth=[[issue_Month]]&expirationYear=[[expire_Year]]&expirationMonth=[[expire_Month]]&certUrl=[[cert_url]]&certId=[[cert_ID]]" contenteditable="false" style="display: inline-flex;min-width: 36px;align-items: baseline !important;border-radius: 6px;
      border-width: 1px;text-decoration:none;border-color: #a0a1a533;background-color: rgb(59 ,130 ,246);padding-left: 12px;padding-right: 12px;padding-top: 6px;padding-bottom: 6px;
      font-weight: 500;font-size: 14px;line-height: 20px;color: white;">
          <img style="width:12px;height:12px;" src="https://print2block.com/img/linkedIn-64.png" />
          <span class="select-none">&nbsp;&nbsp;Add to Profile</span>
          </a></span>`

      // Insert the button HTML at the current selection
      document.execCommand("insertHTML", false, Button)

      // Wait for a tick (next animation frame)
      // await tick()

      // Reset the selection to the next sibling node
      // document.getSelection().setBaseAndExtent(GetNextSibling(anchorNode), 0, GetNextSibling(anchorNode), 0)
    } catch (error) {
      console.error(error)
    }
  }
</script>

{#if showLinkModal}
  <LinkModal
    {selected}
    on:click={() => {
      showLinkModal = false
    }}
    on:insert={(e) => {
      insertLink(e)
      showLinkModal = false
    }}
  />
{/if}

{#if showAttributeModal}
  <AttributeModal
    {parsedJson}
    on:click={() => {
      showAttributeModal = false
    }}
    on:applyAndContinue={(e) => {
      insertAttribute(e)
      showAttributeModal = false
    }}
  />
{/if}

{#if showUserInfoModal}
  <UserinfoModal
    on:click={() => {
      showUserInfoModal = false
    }}
    on:insert={handleBtnInsertion}
  />
{/if}

<!-- on:insert={(e) => {
  insertButton(e)
}} -->

<svelte:document on:selectionchange={handleSelectionChange} />

<div bind:this={mainContainer} class="flex h-full w-full flex-col {showLinkModal ? 'pointer-events-none' : ''}">
  <div bind:this={toolbar} class="mb-3 flex w-full flex-wrap gap-y-3">
    <!-- <StyleDropDown {codeView} bind:activeStyle /> -->
    <div class="px-1">
      <FontDropdown
        {codeView}
        on:familyChosen={() => {
          // Get the current selection
          // let selection = document.getSelection()
          // if (selection.isCollapsed) moveCursorToEnd()

          moveCursorToEnd()
          applyFontFamily(activeFontFamily)
        }}
        bind:activeFontFamily
        bind:activeFontSize
        dropdownItems={fontFamily}
        size={150}
        type="family"
      />
    </div>
    <div class="px-1">
      <FontDropdown
        {codeView}
        bind:activeFontSize
        bind:activeFontFamily
        dropdownItems={fontSize}
        size={60}
        type="Size"
        on:sizeChosen={(e) => {
          moveCursorToEnd()
          applyFontSize(activeFontSize, e.detail)
        }}
      />
    </div>

    <div class="relative flex px-1">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div on:click={changeColor} style:color={textColor} style:background={backgroundColor} data-tooltip="Add Color" tooltip-position="top" type="button" class="flex h-9 w-9 {codeView ? 'cursor-not-allowed' : 'cursor-pointer'} items-center justify-center rounded-l-md bg-gray-50 text-sm font-medium text-gray-800 hover:bg-slate-200 dark:bg-[#2d2d2d] dark:text-gray-200">
        <i class="fa-solid fa-a" />
      </div>
      <Palette bind:textColor colorCount={20} bind:backgroundColor {codeView} on:textClrChosen={changeColor} on:bgClrChosen={changeColor} />
    </div>

    <div class="px-1">
      <button bind:this={boldBtn} on:click={() => toggleStyleExec("bold")} disabled={codeView} data-tooltip="Bold" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-bold pointer-events-none" />
      </button>
    </div>
    <div class="px-1">
      <button bind:this={italicBtn} on:click={() => toggleStyleExec("italic")} disabled={codeView} data-tooltip="Italic" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-italic pointer-events-none" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={underlineBtn} on:click={() => toggleStyleExec("underline")} disabled={codeView} data-tooltip="underline" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-underline pointer-events-none" />
      </button>
    </div>

    <div class="px-1">
      <button disabled={codeView} on:click={removeFormatting} data-tooltip="Remove Font Style" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-eraser pointer-events-none" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={ulBtn} disabled={codeView} on:click={() => createList("insertUnorderedList")} data-tooltip="Unordered List" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-list-ul select-none" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={olBtn} on:click={() => createList("insertOrderedList")} disabled={codeView} data-tooltip="Ordered List" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-list-ol select-none" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={justifyLeft} on:click={() => toggleStyleExec("justifyLeft")} disabled={codeView} data-tooltip="Align Left" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-align-left" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={justifyCenter} on:click={() => toggleStyleExec("justifyCenter")} disabled={codeView} data-tooltip="Align Center" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-align-center" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={justifyRight} on:click={() => toggleStyleExec("justifyRight")} disabled={codeView} data-tooltip="Align Right" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-align-right" />
      </button>
    </div>

    <div class="px-1">
      <button bind:this={justifyFull} on:click={() => toggleStyleExec("justifyFull")} disabled={codeView} data-tooltip="Justify full" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-align-justify" />
      </button>
    </div>

    <div class="px-1">
      <button disabled={codeView} on:click={() => changeIndent("indent")} data-tooltip="indent" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-indent" />
      </button>
    </div>

    <div class="px-1">
      <button on:click={() => changeIndent("outdent")} disabled={codeView} data-tooltip="outdent" tooltip-position="top" type="button" class="toolbar-btn">
        <i class="fa-solid fa-outdent" />
      </button>
    </div>

    <div class="px-1">
      <button
        on:click={() => {
          storeSelection()
          showLinkModal = true
        }}
        disabled={codeView}
        type="button"
        data-tooltip="Create Link"
        tooltip-position="top"
        class="toolbar-btn"
      >
        <i class="fa-solid fa-link-simple" />
      </button>
    </div>

    <div class="px-1">
      <button
        on:click={() => {
          storeSelection()
          showAttributeModal = true
        }}
        disabled={codeView || !Object.keys(parsedJson).length}
        type="button"
        data-tooltip="Insert Attribute"
        tooltip-position="top"
        class="toolbar-btn"
      >
        <i class="fa-solid fa-brackets-curly" />
      </button>
    </div>

    <div class="px-1">
      <button
        on:click={() => {
          storeSelection()
          // insertButton()
          showUserInfoModal = true
        }}
        disabled={codeView}
        type="button"
        data-tooltip="Add LinkedIn Button"
        tooltip-position="top"
        class="toolbar-btn"
      >
        <i class="fa-brands fa-linkedin fa-lg text-blue-500" />
      </button>
    </div>

    <div class="px-1">
      <button on:click={handleQRInclusion} disabled={codeView || !qrSource} type="button" data-tooltip="Add QR" tooltip-position="top" class="toolbar-btn">
        <i class="fa-solid fa-qrcode" />
      </button>
    </div>

    <div class="px-1">
      <button data-tooltip="Code View" tooltip-position="top" type="button" on:click|stopPropagation={changeCodeView} class="toolbar-btn">
        <i class="fa-solid fa-code" />
      </button>
    </div>
  </div>
  {#if codeView}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div contenteditable="true" style="height: {editorHeight}px" on:click|stopPropagation on:input={autoGrowCodeView} bind:this={codearea} bind:innerText={content} class="block w-full resize-none overflow-y-auto rounded-md bg-[#252525] px-3 py-2 pl-5 text-sm text-white shadow-sm outline-none focus:border focus:border-blue-500 focus:ring-1" />
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div on:click={showRange} id="textEditor" style="font-family:Arial;height: {editorHeight}px;background:{color}" contenteditable="true" on:input={autoGrow} bind:this={textarea} bind:innerHTML={content} class="textarea" />
  {/if}
</div>

<style lang="postcss" global>
  .active {
    @apply bg-blue-600 text-white !important;
  }
  .textarea {
    font-size: 13px;
    line-height: 19.5px;
    @apply block w-full resize-none overflow-y-auto rounded-md border border-[#a0a1a580] bg-white px-3 py-2 pl-5 text-black shadow-sm outline-none focus:border focus:border-blue-500 focus:ring-1;
  }
  span {
    background-color: transparent;
  }
  .textarea p {
    margin: revert;
  }
  .textarea #linkedInBtn {
    display: inline-flex !important;
  }
  .textarea ul {
    display: block;
    line-height: 1.5;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .textarea ol {
    display: block;
    list-style-type: decimal;
    line-height: 1.5;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  .textarea a {
    color: revert;
    text-decoration: revert;
  }
  .textarea font,
  .textarea span {
    line-height: 1.6 !important;
  }
  li::marker {
    font-size: revert !important;
  }
  font[size="1"] {
    font-size: 10px;
  }
  font[size="2"] {
    font-size: 11px;
  }
  font[size="3"] {
    font-size: 12px;
  }
  font[size="4"] {
    font-size: 14px;
  }
  font[size="5"] {
    font-size: 18px;
  }
  font[size="6"] {
    font-size: 24px;
  }
  font[size="7"] {
    font-size: 36px;
  }
  .toolbar-btn {
    @apply flex h-9 w-9 select-none items-center justify-center rounded-md bg-gray-50 text-sm font-medium text-gray-900 hover:bg-slate-200 focus:outline-none disabled:cursor-not-allowed dark:bg-[#2d2d2d] dark:text-gray-200 dark:hover:bg-bodyblack dark:hover:text-slate-200;
  }
</style>
